import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useApps } from '@/contexts/AppsContext';

/**
 * AdminRoute — only renders children if user is a system admin.
 * Redirects to /dashboard otherwise.
 */
export function AdminRoute({ children }) {
  const { isAdmin, loading: authLoading } = useAuth();

  // Don't redirect while still checking auth
  if (authLoading) return null;

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

/**
 * OwnerRoute — only renders children if user owns the app (by :appId param).
 * Admins bypass this check (they can inspect any app).
 * Redirects to /apps otherwise.
 */
export function OwnerRoute({ children }) {
  const { isAdmin, loading: authLoading } = useAuth();
  const { apps, loading: appsLoading } = useApps();
  const { appId } = useParams();

  // Don't redirect while still loading
  if (authLoading || appsLoading) return null;

  // Admins can access any app
  if (isAdmin) return children;

  // Check if user owns this app
  const ownsApp = apps.some(a => a.appId === appId);
  if (!ownsApp) {
    return <Navigate to="/apps" replace />;
  }

  return children;
}
